"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressPayService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../../mma/shared/services/restservice");
const http_1 = require("@angular/common/http");
const _ = require("underscore");
class ExpressPayService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.lookupUrl = '/rest-api/account/express-pay/v1/lookup/';
        this.accounturl = '/rest-api/account/v1/details';
        this.handleLoginUrl = '/rest-api/account/express-pay/v1/login/';
        this.billingDetailsUrl = '/rest-api/account/express-pay/v1/details';
        this.fiberBillingDetailsUrl = '/rest-api/account/express-pay/v1/details/fiber';
        this.fiberLoginUrl = '/rest-api/account/express-pay/v1/fiber/login';
        this.accountDetailUrl = '/rest-api/profile/v1/get/personalInfo/expressPay';
        this.allStateListUrl = '/rest-api/misc/v1/states?allStates=true';
        this.savedCard = '/rest-api/account/payment/creditcard/v1/savedDetails/expressPay';
        this.payByCC = '/rest-api/account/payment/creditcard/v1/save/expressPay';
        this.errorMsgUrl = '/resources/json/mma/feerrormsg.json';
        this.submitPaymentGiftCard = '/rest-api/account/payment/giftcard/v1/submit/expressPay';
        this.submitPayment = '/rest-api/account/payment/creditcard/v1/submit/expressPay';
        this.sessionIdUrl = '/rest-api/profile/v1/riskSessionId/';
        this.bankAvailabilityCheckUrl = '/rest-api/account/payment/bank/v1/isAvailable/';
        this.saveBankAccountDetailsUrl = '/rest-api/account/payment/bank/v1/save/expressPay';
        this.savePaymentThroughGiftCardURL = '/rest-api/account/payment/giftcard/v1/save/expressPay';
        this.giftCardUrl = '/rest-api/account/payment/giftcard/v1/checkBalance/';
        this.getGenericContentcheckPayTemporarilyDisabledUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=/generic/instructional/checkPayTemporarilyDisabled';
        this.submitBankAccountDetailsUrl = '/rest-api/account/payment/bank/v1/submit/expressPay';
        this.submitPaymentThroughGiftCardURL = '/rest-api/account/payment/giftcard/v1/submit/expressPay';
        this.paymentEligiblityUrl = '/rest-api/account/payment/v1/extend/eligibility/expressPay';
        this.extendPayment = '/rest-api/account/payment/v1/extend/expressPay';
        // Home services urls
        this.payByCCHS = '/rest-api/fiber/payment/creditcard/v1/reviewPayment/expressPay';
        this.saveBankAccountDetailsHSUrl = '/rest-api/fiber/payment/bank/v1/reviewPayment/expressPay';
        this.submitBankAccountDetailsHSUrl = '/rest-api/fiber/payment/bank/v1/submit/expressPay';
        this.submitCreditCardDetailsHSUrl = '/rest-api/fiber/payment/creditcard/v1/submit/expressPay';
        this.fiberLastBillUrl = '/rest-api/account/express-pay/v1/fiber-bill';
        this.linkFiberToWireless = '/rest-api/account/link/v1/wirelessAccount/expressPay';
        this.linkToWirelessPin = '/rest-api/account/link/v1/updateFiberAccount/expressPay';
        this.fiberBillingAddressUrl = '/rest-api/fiber/account/profile/v1/get/personalInfo/expressPay';
        this.fiberLinkedStatusUrl = '/rest-api/account/express-pay/v1/isLinked ';
        this.submitGiftCardDetailsHSUrl = '/rest-api/fiber/payment/giftcard/v1/submit/expressPay';
        this.saveGiftCardDetailsHSUrl = '/rest-api/fiber/payment/giftcard/v1/reviewPayment/expressPay';
        this.hsPaymentEligiblityUrl = '/rest-api/fiber/account/payment/v1/extend/eligibility/expressPay';
        this.hsExtendPaymentUrl = '/rest-api/fiber/account/payment/v1/extend/expressPay';
        // Prepaid services urls
        this.prepaidBillingDetailsUrl = '/rest-api/account/express-pay/v1/details/prepaid';
        this.fiberAccountUrl = '/rest-api/fiber/account/services/v1/details/expressPay';
        this.cpniCheckUrl = '/rest-api/fiber/account/cpni/v1/check/expressPay';
        this.hsaccountSummaryUrl = '/rest-api/fiber/account/bill/v1/details/expressPay';
        this.loginAuthenticationUrl = '/rest-api/account/express-pay/v1/isAuthenticated/';
        this.getSchedulePaymentUrl = '/rest-api/account/scheduledPayment/v1/details/expressPay';
        this.cancelSchedulePaymentUrl = '/rest-api/account/scheduledPayment/v1/cancel/expressPay';
        this.getAutopayMethodUrl = '/rest-api/account/autopay/v1/details/expressPay';
        this.getSessionIdUrl = '/rest-api/profile/v1/sessionId';
        this.logOutUrl = '/rest-api/profile/v1/signOut';
        this.profileStateUrl = '/global/profileController.jsp?action=getProfileState';
        this.kountUrl = '/rest-api/account/payment/v1/paymentcollector';
        this.validateReCaptchaUrl = '/rest-api/antispam/recaptcha/v2/validateReCaptcha';
        this.captchaSiteKeyUrl = '/rest-api/antispam/recaptcha/v2/siteKey';
        // Prepaid-SDR - get Renewal Date Eligibility
        this.getRenewalDateEligibilityUrl = '/rest-api/account/renewal/v1/eligibility';
        // Get Service Fee
        this.getCreditCardServiceFeeUrl = '/rest-api/account/payment/thirdparty/v1/getTenderFee';
        this.emitSignedInStatus = new rxjs_1.BehaviorSubject([]);
        this.signedInStatusEmitted$ = this.emitSignedInStatus.asObservable();
    }
    expressPayLogin(content) {
        return this.post(this.handleLoginUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getBillingDetails() {
        return this.get(this.billingDetailsUrl).pipe(operators_1.map((data) => data));
    }
    getFiberBillingDetails() {
        return this.get(this.fiberBillingDetailsUrl).pipe(operators_1.map((data) => data));
    }
    getPrepaidBillingDetails() {
        return this.get(this.prepaidBillingDetailsUrl).pipe(operators_1.map((data) => data));
    }
    // Observable string sources
    emitSignedInStatusChange(change) {
        this.emitSignedInStatus.next(change);
    }
    setSignedIn(signedInStatus) {
        this.signedInStatus = signedInStatus;
    }
    getSignedIn() {
        return this.signedInStatus;
    }
    handleFiberLogin(formData) {
        let inputArgs;
        if (!_.isEmpty(formData) && formData.fiberPhoneNumber) {
            inputArgs = new http_1.HttpParams().set('fiberPhoneNumber', formData.fiberPhoneNumber).set('fiberZipCode', formData.fiberZipCode);
        }
        else if (!_.isEmpty(formData)) {
            inputArgs = new http_1.HttpParams().set('fiberAccountNumber', formData.fiberAccountNumber).set('fiberZipCode', formData.fiberZipCode);
        }
        return this.post(this.fiberLoginUrl, inputArgs.toString()).pipe(operators_1.map((data) => {
            this.fiberAccDetails = data;
            return data;
        }));
    }
    getPersonalInformation() {
        return this.get(this.accountDetailUrl).pipe(operators_1.map((data) => data));
    }
    getSessionId() {
        return this.get(this.sessionIdUrl).pipe(operators_1.map((data) => data));
    }
    getAllStatesList() {
        return this.get(this.allStateListUrl).pipe(operators_1.map((data) => data));
    }
    payByCreditCard(content) {
        return this.post(this.payByCC, content, true).pipe(operators_1.map((data) => data));
    }
    getCSErrorMessage() {
        if (this.csErrorMessageData) {
            return rxjs_1.of(this.csErrorMessageData);
        }
        else {
            return this.get(this.errorMsgUrl).pipe(operators_1.map((data) => {
                this.observable = null;
                this.csErrorMessageData = data;
                return data;
            }));
        }
    }
    submitFinalPaymentGiftCard(content) {
        return this.post(this.submitPaymentGiftCard, content, true).pipe(operators_1.map((data) => data));
    }
    submitFinalPayment(content) {
        return this.post(this.submitPayment, content, true).pipe(operators_1.map((data) => data));
    }
    getAccountDetails(cacheResponse) {
        if (this.accountData && cacheResponse !== false) {
            return rxjs_1.of(this.accountData);
        }
        else {
            return this.get(this.accounturl).pipe(operators_1.map((data) => {
                this.observable = null;
                this.accountData = data;
                return data;
            }));
        }
    }
    checkBankAvailabilityOption() {
        return this.get(this.bankAvailabilityCheckUrl).pipe(operators_1.map((data) => data));
    }
    saveBankAccountDetails(content) {
        return this.post(this.saveBankAccountDetailsUrl, content, true).pipe(operators_1.map((data) => {
            console.log('data', data);
            return data;
        }));
    }
    savePaymentByGiftCard(content) {
        return this.post(this.savePaymentThroughGiftCardURL, content, true).pipe(operators_1.map((data) => data));
    }
    // Home services Gift card Save
    savePaymentByGiftCardHS(content) {
        return this.post(this.saveGiftCardDetailsHSUrl, content, true).pipe(operators_1.map((data) => data));
    }
    // Home Service Payment Arrangement
    getHSPaymentExtensionEligiblity() {
        return this.get(this.hsPaymentEligiblityUrl).pipe(operators_1.map((data) => data));
    }
    getHSExtendPaymentDate() {
        return this.post(this.hsExtendPaymentUrl, {}).pipe(operators_1.map((data) => data));
    }
    getGiftCardBalanceDetails(giftCardNumber, giftCardPin) {
        const inputArgs = new http_1.HttpParams().set('giftCardNo', giftCardNumber)
            .set('pin', giftCardPin);
        return this.post(this.giftCardUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    genericContentPayTemporarilyDisabled() {
        return this.get(this.getGenericContentcheckPayTemporarilyDisabledUrl).pipe(operators_1.map((data) => data));
    }
    submitBankAccountDetails(content) {
        return this.post(this.submitBankAccountDetailsUrl, content, true).pipe(operators_1.map((data) => {
            console.log('data', data);
            return data;
        }));
    }
    submitPaymentByGiftCard(content) {
        return this.post(this.submitPaymentThroughGiftCardURL, content, true).pipe(operators_1.map((data) => data));
    }
    getPaymentExtensionEligiblity() {
        return this.get(this.paymentEligiblityUrl).pipe(operators_1.map((data) => data));
    }
    getExtendPaymentDate() {
        return this.post(this.extendPayment, {}).pipe(operators_1.map((data) => data));
    }
    // Home Services Gift card  submit
    submitPaymentByGiftCardHS(content) {
        return this.post(this.submitGiftCardDetailsHSUrl, content, true).pipe(operators_1.map((data) => data));
    }
    // Fiber Services
    getFiberBillingAddress() {
        return this.get(this.fiberBillingAddressUrl).pipe(operators_1.map((data) => data));
    }
    payByCreditCardHS(content) {
        return this.post(this.payByCCHS, content, true).pipe(operators_1.map((data) => data));
    }
    saveBankAccountDetailsHS(content) {
        return this.post(this.saveBankAccountDetailsHSUrl, content, true).pipe(operators_1.map((data) => {
            console.log('data', data);
            return data;
        }));
    }
    submitBankAccountDetailsHS(content) {
        return this.post(this.submitBankAccountDetailsHSUrl, content, true).pipe(operators_1.map((data) => {
            console.log('data', data);
            return data;
        }));
    }
    submitCreditCardDetailsHS(content) {
        return this.post(this.submitCreditCardDetailsHSUrl, content, true).pipe(operators_1.map((data) => {
            console.log('data', data);
            return data;
        }));
    }
    getFiberLastBill() {
        return this.get(this.fiberLastBillUrl).pipe(operators_1.map((data) => data));
    }
    linkFiberToWirelessMdn(formData) {
        const inputArgs = new http_1.HttpParams().set('mobileNumber', formData.mobileNumber);
        return this.post(this.linkFiberToWireless, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getFiberLinkedStatus() {
        return this.get(this.fiberLinkedStatusUrl).pipe(operators_1.map((data) => data));
    }
    manageWirelessAccountPin(formData) {
        const inputArgs = new http_1.HttpParams().set('pin', formData.pin);
        return this.post(this.linkToWirelessPin, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    loginAuthentication() {
        return this.get(this.loginAuthenticationUrl).pipe(operators_1.map((data) => data));
    }
    getHSaccountSummary() {
        return this.get(this.hsaccountSummaryUrl).pipe(operators_1.map((data) => data));
    }
    cpniCheck() {
        return this.get(this.cpniCheckUrl).pipe(operators_1.map((data) => data));
    }
    getFiberAccDetails() {
        return this.get(this.fiberAccountUrl).pipe(operators_1.map((data) => {
            this.fiberAccDetails = data;
            return data;
        }));
    }
    getScheduledPayment() {
        return this.get(this.getSchedulePaymentUrl).pipe(operators_1.map((data) => data));
    }
    cancelScheduledPayment() {
        return this.delete(this.cancelSchedulePaymentUrl).pipe(operators_1.map((data) => data));
    }
    getAutoPayType() {
        return this.get(this.getAutopayMethodUrl).pipe(operators_1.map((data) => data));
    }
    getSessioId() {
        return this.get(this.getSessionIdUrl).pipe(operators_1.map((data) => data));
    }
    logOut(sessionId) {
        const inputArgs = new http_1.HttpParams().set('dynSessConf', sessionId);
        return this.post(this.logOutUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getProfileState() {
        return this.get(this.profileStateUrl).pipe(operators_1.map((data) => data));
    }
    getPaymentCollector() {
        return this.get(this.kountUrl).pipe(operators_1.map((data) => data));
    }
    getPrepaidInfo(fomData) {
        return this.post(this.lookupUrl, fomData, true).pipe(operators_1.map((data) => data));
    }
    validateReCaptcha(content) {
        return this.post(this.validateReCaptchaUrl, content, true).pipe(operators_1.map((data) => data));
    }
    captchaSiteKey() {
        return this.get(this.captchaSiteKeyUrl)
            .pipe(operators_1.map((data) => data));
    }
    // Prepaid-SDR - get Renewal Date Eligibility
    getRenewalDateEligibility(cacheResponse) {
        return this.get(this.getRenewalDateEligibilityUrl).pipe(operators_1.map((data) => data));
    }
    getServiceFee(tenderFeeRequest) {
        return this.post(this.getCreditCardServiceFeeUrl, tenderFeeRequest, true).pipe(operators_1.map((data) => data), operators_1.catchError((error) => {
            throw error.message;
        }));
    }
}
exports.ExpressPayService = ExpressPayService;
//# sourceMappingURL=expresspay.services.js.map